import { useEffect, useRef } from "react";

/**
 * Repaints a canvas whenever the active theme or the recolored Karel sprites
 * change. The latest `onRepaint` is read from a ref so callers can pass an
 * inline closure without re-subscribing on every render.
 */
export function useCanvasRepaint(onRepaint: () => void): void {
  const callbackRef = useRef(onRepaint);
  callbackRef.current = onRepaint;

  useEffect(() => {
    const repaint = (): void => callbackRef.current();
    window.addEventListener("karel:theme-changed", repaint);
    window.addEventListener("karel:images-updated", repaint);
    return () => {
      window.removeEventListener("karel:theme-changed", repaint);
      window.removeEventListener("karel:images-updated", repaint);
    };
  }, []);
}
